import { PropsWithChildren } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

const client = new QueryClient();

export function ReactQueryProvider(props: PropsWithChildren<unknown>) {
  return <QueryClientProvider client={client}>{props.children}</QueryClientProvider>;
}
